import { CustomNode } from '../../../types';
import { shapeNames } from '../../constants';
import { channelOptIcon } from '../../../icons';
import { sendActionOptions } from './sendAction.constants';

export const CHO_WIDTH = 293;
export const CHO_HEIGHT = 68;

export const channelOptConfig: CustomNode = {
  getCustomConfig() {
    return {
      ...sendActionOptions,
      icon: channelOptIcon,
      [shapeNames.wrapper]: {
        lineWidth: 2,
        stroke: 'l(0) 0.068:#B86CC3 0.96:#F95086',
      },
      [shapeNames.divider]: {
        height: 2,
        isFullWidth: true,
        padding: [0, 1],
      },
      size: [CHO_WIDTH, CHO_HEIGHT],
      footerStartY: 68,
    };
  },
};
